import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlineLoader from "@Shared/components/general/inline-loader.vue";
import PageHeader from "@Shared/components/general/page-header";
import SettingsNavigation from "@Shared/components/settings/settings-navigation";
import AccountContainer from "@Client/js/modules/settings/account/components/account-container";
import NotificationsContainer from "@Client/js/modules/settings/notifications/components/notifications-container";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientSettingsContainer",
  title() {
    return this.$t("sidebar.sections.settings");
  },
  components: {
    SettingsNavigation,
    AccountContainer,
    NotificationsContainer,
    PageHeader,
    InlineLoader
  },
  props: {
    tab: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      currentTab: "",
      saving: false,
      savingStatus: false,
      allowSave: false,
      settingsType: "personal-settings"
    };
  },
  computed: {
    tabs() {
      return [{
        key: "account",
        label: this.$t("settings.tabs.account"),
        component: "account-container"
      }, {
        key: "notifications",
        label: this.$t("settings.tabs.notifications"),
        component: "notifications-container"
      }];
    },
    currentTabComponent() {
      var _this$tabs$find$compo, _this$tabs$find, _context;
      return (_this$tabs$find$compo = (_this$tabs$find = _findInstanceProperty(_context = this.tabs).call(_context, tab => tab.key === this.currentTab)) == null ? void 0 : _this$tabs$find.component) != null ? _this$tabs$find$compo : null;
    }
  },
  mounted() {
    this.setInitialCurrentTab();
  },
  methods: {
    handleTabChange(tab) {
      this.currentTab = tab;
      this.allowSave = false;
    },
    startSaving() {
      this.saving = true;
    },
    finishSaving() {
      this.saving = false;
      this.allowSave = false;
    },
    handleAllowSave(canSave) {
      this.allowSave = canSave;
    },
    setInitialCurrentTab() {
      const metaTab = this.$route.meta.tab;
      this.currentTab = metaTab || this.tabs[0].key;
      Amplitude.logEvent(`Client Settings - ${this.currentTab} visited`);
    }
  }
});